import { v1Service as e } from "./V1Service.js";
const o = {
  v1: e
};
export {
  o as services
};
